import React from 'react';
import StudyNavbar from './StudyNavbar';
import StudyProgressStrip from './StudyProgressStrip';
import StudyFooter from './StudyFooter';
import './StudyShell.css';

/**
 * StudyShell
 * Outer chrome for the redesigned Study mode. Composes the top navbar,
 * card header, progress strip, footer, and hosts arbitrary children
 * (the card body) below. Keeps Study.js focused on logic + content while
 * letting the shell evolve independently.
 *
 * Visual reference: flashcode_study_byte.html / flashcode_study_no_byte.html.
 */
const StudyShell = ({
  // navbar
  snippetIcon,
  cookbookName,
  sectionName,
  streak,
  // progress
  total,
  currentIndex,
  cards,
  sessionCardStatuses = [],
  onProgressDotClick,
  onPrev,
  onNext,
  onOpenCookbookIndex,
  cookbookIndexOpen = false,
  prevDisabled,
  nextDisabled,
  nextHighlighted = false,
  showProgressDots = true,
  practiceNavMode = null,
  onPracticeNavModeChange,
  nextLabel = 'Next',
  // footer — result feedback after Check
  lastResult,
  // body
  cardHeader,
  // body
  children,
  className = ''
}) => {
  return (
    <div className={`study-shell ${className}`.trim()}>
      <StudyNavbar
        snippetIcon={snippetIcon}
        cookbookName={cookbookName}
        sectionName={sectionName}
        streak={streak}
      />
      {cardHeader}
      <StudyProgressStrip
        total={total}
        currentIndex={currentIndex}
        cards={cards}
        sessionCardStatuses={sessionCardStatuses}
        onDotClick={onProgressDotClick}
        onPrev={onPrev}
        onNext={onNext}
        onOpenCookbookIndex={onOpenCookbookIndex}
        cookbookIndexOpen={cookbookIndexOpen}
        prevDisabled={prevDisabled}
        nextDisabled={nextDisabled}
        nextHighlighted={nextHighlighted}
        showProgressDots={showProgressDots}
        practiceNavMode={practiceNavMode}
        onPracticeNavModeChange={onPracticeNavModeChange}
        nextLabel={nextLabel}
      />
      <div className="study-shell__body">{children}</div>
      <StudyFooter lastResult={lastResult} />
    </div>
  );
};

export default StudyShell;
